import React, {useEffect, useRef, useState} from 'react';
import 'chartjs-adapter-luxon';

import {Bar} from "react-chartjs-2";
import commaSeparator from "../../../utils/CommaSeparator";
import {Chart, ArcElement, LinearScale, PointElement, Tooltip, Legend, TimeScale} from "chart.js";

Chart.register(LinearScale, PointElement, Tooltip, Legend, TimeScale);


const MyGanttChart = (props) => {
  const [data, setData] = useState(props.data);
  const [optionsState, setOptionsState] = useState({});


  useEffect(() => {

    // const customOptions = optionsState;
    const customOptions = props.options!==undefined ? props.options : {};
    const daysArray = []

    if(Object.keys(customOptions).length > 0) {

    const diffDaysInSeconds = Math.floor(new Date(customOptions.scales.x.max).getTime() / 1000) - Math.floor(new Date(customOptions.scales.x.min).getTime() / 1000);
    const days = diffDaysInSeconds / (86400); //   24*60*60===86400;
    const startDateMiladi = new Date(customOptions.scales.x.min).toLocaleDateString();
    // const startDateJalali = new Date(optionsState.scales.x.max).toLocaleDateString('fa-ir');
    let tempTimeStamp = new Date(startDateMiladi).getTime();
    for (let i = 1; i < days+10; i++) {
      // TimeStamp To jalali Add To array
      daysArray.push(new Date(tempTimeStamp).toLocaleDateString('fa-ir'));
      // got To Tomorrow
      tempTimeStamp += (86400 * 1000);
    }

    customOptions.scales.x.ticks = {
      callback: function (val, index) {
        // //debugger
        return daysArray[index];
      },
      // color: 'red',
    };

    setOptionsState(customOptions);
    }

  }, [data])

  return   <Bar
      data={props.data}
      options={optionsState}
      // style={{maxHeight: "50%",maxWidth: "15%"}}
    />

  // return <Chart
  //   chartType="ScatterChart"
  //   data={[["Age", "Weight"], [4, 5.5], [8, 12]]}
  //   width="100%"
  //   height="400px"
  //   legendToggle
  // />
};

export default MyGanttChart;
